<template>
  <div >
    <b-navbar toggleable="lg" type="msstream" variant="navbar-msstream">
      
      <b-navbar-brand href="#/" style="color:00b0ff !important;padding:10px;">
        <b-img fluid :src="require(`@/assets/logo_Q_PlatformUI_W.svg`)" class="logonavbar" v-if="type === 'platform' || type === 'camera'"></b-img>
        <b-img fluid :src="require(`@/assets/logo_Q_PluginUI_W.svg`)" class="logonavbar" v-if="type === 'plugin'"></b-img>
        <b-img fluid :src="require(`@/assets/logo_Q_W.svg`)" class="logonavbar" v-if="['plugin', 'platform', 'camera'].indexOf(type) === -1"></b-img>
      </b-navbar-brand>
      <b-navbar-nav v-if="isAuthenticated && $auth.getMyUser().roles.indexOf('admin') > -1" class="auto" left>
        <b-nav-item class="navitem2" :style="($route.name === 'admin')?'background-color:white;border-radius:3px':''" href="#/admin">
          <div :style="($route.name === 'admin')?'color:#14BF98; font-weight:bold; ':''">
              <font-awesome-icon icon="user"></font-awesome-icon> ADMIN: {{view}}
            </div>
        </b-nav-item>
      </b-navbar-nav>

      <b-navbar-nav class="auto" left style="margin-right:15px">
        <b-nav-item  
          v-if="isAuthenticated && type === 'platform' && client.clientname !== 'viewsurf'" 
          @click="emitChat()" 
          >
            <div class="navSmallFont" v-if="unreadMessages===0">
              <font-awesome-icon icon="comments"></font-awesome-icon>
            </div>
            <div class="navSmallFont" v-if="unreadMessages>0 && unreadMessages <=10">
              <font-awesome-icon icon="comments"></font-awesome-icon>
              <span class="badge">{{unreadMessages}}</span>
            </div>
            <div class="navSmallFont" v-if="unreadMessages>10">
              <font-awesome-icon icon="comments"></font-awesome-icon>
              <span class="badge">10+</span>
            </div>
        </b-nav-item>

        <!--
        <b-nav-item  
          v-if="client.support && isAuthenticated && type === 'platform' && user.username != 'quanteec'" 
          @click="OpenChatSupport()"
          title="Contact QUANTEEC team directly by Chat" 
          >
            <b-img fluid :src="require(`@/assets/logo.svg`)" style="height:15px"></b-img>
            <font-awesome-icon :icon="['far', 'comment']" transform="shrink-3 up-3 left-3"></font-awesome-icon>
        </b-nav-item>
        -->

      </b-navbar-nav>


      <b-button-group>
      <b-button
        size="sm"
        :variant="($ml.current === lang) ? 'greenw':'trans'"
        v-for="lang in $ml.list"
        :key="lang"
        @click="$ml.change(lang)"
        v-text="lang"
      ></b-button>
      </b-button-group>

      <b-navbar-toggle target="nav_collapse"><font-awesome-icon style="color: white" icon="bars"></font-awesome-icon></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="ml-auto" right>
          <!-- Plug In -->
          <b-nav-item class="navitem2" :style="($route.name === 'videolistPlugin')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && type === 'plugin'" href="#/videosplugin">
            <div class="navSmallFont" :style="($route.name === 'videolistPlugin')?'color:#14BF98; font-weight:bold; ':''">
              <font-awesome-icon icon="play"></font-awesome-icon> VIDEOS
            </div>
          </b-nav-item>
          <b-nav-item class="navitem2" :style="($route.name === 'config')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && type === 'plugin'" href="#/pluginconfig">
            <div class="navSmallFont" :style="($route.name === 'config')?'color:#14BF98; font-weight:bold; ':''">
              <font-awesome-icon icon="book-open"></font-awesome-icon> CONFIG DOC
            </div>
          </b-nav-item>

          <!--
          <b-nav-item class="navitem2" :style="($route.name && $route.name.indexOf('doc') > -1)?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && type === 'plugin'" href="#/doc">
            <div class="navSmallFont" :style="($route.name && $route.name.indexOf('doc') > -1)?'color:#14BF98; font-weight:bold; ':''">
              <font-awesome-icon icon="book-open"></font-awesome-icon> DOC
            </div>
          </b-nav-item>
          -->

          <!-- Platform -->
            <b-nav-item class="navitem2" :style="($route.name === 'videos')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && type === 'platform'" href="#/">
                            
              <div class="navSmallFont" :style="($route.name === 'videos')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-icon icon="play"></font-awesome-icon> 
                VIDEOS
              </div>
              
              <!--
              <b-button
                size="sm" 
                :variant="($route.name === 'videos')?'greenw':'trans'">
                <font-awesome-icon icon="play"></font-awesome-icon> 
                VIDEOS
              </b-button>
              -->
            </b-nav-item>

            <b-nav-item class="navitem2" :style="($route.name === 'vireed')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && type === 'platform' && client.vireed" href="#/vireed">
              <div class="navSmallFont" :style="($route.name === 'vireed')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-layers style="margin-right:2px">
                  <font-awesome-icon icon="play" transform="shrink-9" />
                  <font-awesome-icon :icon="['far', 'comment-alt']" transform="grow-4 down-2" />
                </font-awesome-layers>&nbsp;
                <span v-text="$ml.get('projects')"></span>
              </div>
            </b-nav-item>

            <b-nav-item class="navitem2" :style="($route.name === 'export')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && (isManager || isEditor) && type === 'platform' && client.export" href="#/export">
              <div class="navSmallFont" :style="($route.name === 'export')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-layers>
                  <font-awesome-icon :icon="['fas', 'file-export']" size="lg" transform="shrink-8" />
                  <font-awesome-icon :icon="['far', 'circle']" size="lg" />
                </font-awesome-layers>&nbsp;
                <span v-text="$ml.get('exportlinks')"></span>
              </div>
            </b-nav-item>

            <b-nav-item class="navitem2" :style="($route.name === 'scene lists')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && (isManager || isEditor) && type === 'platform' && client.scenelist " href="#/scenelist">
              <div class="navSmallFont" :style="($route.name === 'scene lists')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-layers >
                  <font-awesome-icon :icon="['fas', 'play']" transform="shrink-3 right-4" />
                  <font-awesome-icon :icon="['fas', 'list']" transform="shrink-3 left-4" />
                </font-awesome-layers>
                S.LISTS
              </div>
            </b-nav-item>

            <!--
            <b-nav-item-dropdown html="<span id=myOptions >OPTIONS</span>" class="navitem2 navitemcolor" :style="(['vireed', 'export', 'scene lists', 'direct stream', 'config'].indexOf($route.name) > -1)?'background-color:white; border-radius:3px; color:#14BF98 !important;font-weight:bold;':''" v-if="isAuthenticated && type === 'platform'">
            <b-dropdown-item :style="($route.name === 'vireed')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && type === 'platform' && client.vireed" href="#/vireed">
              <div :style="($route.name === 'vireed')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-icon icon="project-diagram"></font-awesome-icon> VIREED
              </div>
            </b-dropdown-item>

            <b-dropdown-item :style="($route.name === 'vireed')?'background-color:white;border-radius:3px':''" 
            v-if="isAuthenticated && type === 'platform'" 
            @click="emitChat()" 
            >
              <div>
                <font-awesome-icon icon="comments"></font-awesome-icon> CHAT
              </div>
            </b-dropdown-item>

            <b-dropdown-item :style="($route.name === 'export')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && (isManager || isEditor) && type === 'platform' && client.export" href="#/export">
              <div :style="($route.name === 'export')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-layers >
                  <font-awesome-icon :icon="['fas', 'file-export']" size="lg" transform="shrink-8" />
                  <font-awesome-icon :icon="['far', 'circle']" size="lg" />
                </font-awesome-layers>&nbsp;
                EXPORT LINKS
              </div>
            </b-dropdown-item>

            <b-dropdown-item :style="($route.name === 'scene lists')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && (isManager || isEditor) && type === 'platform' && client.scenelist" href="#/scenelist">
              <div :style="($route.name === 'scenelist')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-icon icon="list"></font-awesome-icon>
                SCENE LISTS
              </div>
            </b-dropdown-item>-->

            <!--<b-dropdown-item :style="($route.name === 'direct stream')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && (isManager || isEditor) && type === 'platform' && client.directstream" href="#/directstream">
              <div :style="($route.name === 'directstream')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-icon icon="play"></font-awesome-icon>
                DIRECT STREAM
              </div>
            </b-dropdown-item>
            <b-dropdown-item :style="($route.name === 'config')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && type === 'platform'" href="#/pluginconfig">
              <div :style="($route.name === 'config')?'color:#14BF98; font-weight:bold; ':''">
                <font-awesome-icon icon="cogs"></font-awesome-icon> MESH DELIVERY CONFIG
              </div>
            </b-dropdown-item>
            </b-nav-item-dropdown>-->
          
          <!-- GLOBAL -->
          <b-nav-item class="navitem2" :style="($route.name === 'analytics')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && (isManager || isEditor)" href="#/analytics">
            <div class="navSmallFont" :style="($route.name === 'analytics')?'color:#14BF98; font-weight:bold; ':''">
              <font-awesome-icon icon="chart-line"></font-awesome-icon> ANALYTICS
            </div>
          </b-nav-item>
          <!--<b-nav-item class="navitem2" :style="($route.name === 'admin')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated && isAdmin" href="#/admin">
            <div :style="($route.name === 'admin')?'color:#14BF98; font-weight:bold; ':''">
              <font-awesome-icon icon="user"></font-awesome-icon> ADMIN: {{view}}
            </div>
          </b-nav-item> -->
          <b-nav-item class="navitem2" :style="($route.name === 'profil')?'background-color:white;border-radius:3px':''" v-if="isAuthenticated" href="#/profil">
            <div class="navSmallFont divCut" :style="($route.name === 'profil')?'color:#14BF98; font-weight:bold; ':''">
              <font-awesome-icon icon="user"></font-awesome-icon> 
              {{user.username.toUpperCase()}}
            </div>
          </b-nav-item>

          <b-nav-item class="navitem2" v-if="isAuthenticated" v-on:click="showModal('logoutModal')" title="Log out of QUANTEEC">
            <div class="navSmallFont">
              <font-awesome-icon icon="sign-out-alt" />
            </div>  
          </b-nav-item>
          <!--<b-nav-item class="navitem2" v-if="!isAuthenticated" href="#/auth"><font-awesome-icon icon="sign-in-alt"></font-awesome-icon> LOG IN</b-nav-item>-->
        </b-navbar-nav>

      </b-collapse>
    </b-navbar>

    <b-alert variant="danger" v-if="isAuthenticated && client.dataToDelete" show><p>This client account and all its data will be deleted soon.</p>
    <div v-if="isAuthenticated && isManager"><p>Please send an email to contact@quanteec.com if you change your mind (or go to your profile and click the 'keep account' button).</p></div></b-alert>

    <b-modal ref="logoutModal" hide-footer hide-header>
      <div class="d-block text-center">
        <h4 style="border-bottom:1px solid #2a5d77; padding:10px">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'sign-out-alt']" />
          {{$ml.get('logout')}}
        </h4>
      </div>
      <p style="line-height:normal" v-text="$ml.get('logouttxt')"></p>
      <b-row class="justify-content-around">
        <b-btn class="col-md-5 col-5" variant="msstreamblue" @click="logout();hideModal('logoutModal')">
          <font-awesome-icon style="margin-right:5px" :icon="['fas', 'sign-out-alt']" />
          {{$ml.get('logoutbtn')}}
        </b-btn>
        <b-btn class="col-md-5 col-5" variant="quanteeclg" @click="hideModal('logoutModal')">
          <font-awesome-icon style="margin-right:5px; color:red" :icon="['fas', 'times']" />
          {{$ml.get('cancel')}}
        </b-btn>
      </b-row>
    </b-modal>

  </div>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import AlertDeletion from '@/components/AlertDeletion'
import ChatRoomService from '@/services/chat.service.js'
import { io } from "socket.io-client";
import {WS_CHAT, WS_CHAT_PATH, BASE_URL} from "@/services/base-url.js"

var crService = new ChatRoomService()
var ws_chat_url = WS_CHAT;
var ws_chat_path = WS_CHAT_PATH;

export default {
  name: 'Navbar',
    components: {
    AlertDeletion,
  },
  data: function () {
    return {
        count: 0,
        isAuthenticated: false,
        isManager: false,
        isEditor: false,
        isAdmin: false,
        user:{},
        view: '',
        type: '',
        client: {},
        unreadMessages:0,
        socketChat:null,
    }
   },
   watch:{
    $route (to, from){
        if (['vireed', 'export', 'scene lists', 'direct stream', 'config'].indexOf(to.name) > -1) {
          try {
            let elem = document.getElementById('myOptions');
            elem.innerText = to.name.toUpperCase();
            elem.parentNode.parentNode.style.color = "#14BF98";
          } catch(err) {}
        } else {
          try {
           let elem = document.getElementById('myOptions');
           elem.innerText = 'OPTIONS';
           elem.parentNode.parentNode.style.color = "#fff";
          } catch(err) {}
        }
        if (to.name === "auth") {
          EventBus.$emit('closeAllWindows');
          this.logout();
        }
    }
  },
   mounted: function() {
     EventBus.$on('AuthCheck', this.bigCheck);
     EventBus.$on('AuthChanged', this.onAuthChanged);
     EventBus.$on('ViewChanged', this.onViewChanged);
     EventBus.$on('updateChatIcon', this.checkUnreadMessages);
     this.onAuthChanged();
     this.bigCheck();
     this.connectToChatServer();
     this.checkUnreadMessages();  
   },
   computed: {
     colorClass() {
       return 'navitem2 ' + (this.$route)
     }
   },
   methods: {
    onViewChanged(pseudo) {
      this.view = pseudo;
    },
    reset() {
        this.isAuthenticated = false;
        this.isManager = false;
        this.isEditor = false;
        this.isAdmin = false;
        this.isVireed = false;
        this.user = {};
        this.view = '';
        this.type = '';
        this.client = {};
    },
    onAuthChanged() {
      this.reset();
      this.isAuthenticated = this.$auth.check();
      if (this.isAuthenticated == false) {
        if (window.location.href.indexOf('/#/auth') === -1) {
          this.$router.push('/auth');
        }
      } else {
        this.user = this.$auth.getMyUser();
        if (this.user.roles.indexOf('manager') > -1) {
          this.isManager = true;
        }
        if (this.user.roles.indexOf('editor') > -1) {
          this.isEditor = true;
        }
        this.isVireed = true;

        if (this.user.roles.indexOf('admin') > -1) {
          this.isAdmin = true;
        }
      }
      if (this.isAuthenticated && this.user.roles.indexOf("admin") > -1) {
        this.view = this.$auth.getMyClientView() || this.$auth.getMyUser().client;
      }
      if (this.user.client_infos && this.user.client_infos[0]) {
        this.client = this.user.client_infos[0];
        if (this.user.client_infos[0].type) {
          this.type = this.user.client_infos[0].type;
        }
      }
    },
    bigCheck()  {
      this.$auth.validateWithServer().then(() => {
        this.onAuthChanged();
      }).catch((err) => {
        this.onAuthChanged();
        if (window.location.href.indexOf('/#/auth') === -1) {
          this.$router.push('/auth');
        }
      })
    },
    logout() {
        this.$auth.logout();
        this.onAuthChanged();
        if (window.location.href.indexOf('/#/auth') === -1) {
          this.$router.push('/auth');
        }
    },
    showModal (ref, video) {
      this.currentVideo = video;
      this.$refs[ref].show();
    },
    hideModal (ref) {
      this.$refs[ref].hide();
    },
    emitChat()
    {
      EventBus.$emit('chat');
    },
    checkUnreadMessages()
    {
      crService.checkUnseenMessages(this.$auth.token()).then(data=>
      {
        this.unreadMessages = data.unseenMessages;
      })
    },
    connectToChatServer(){
      this.socketChat = io(ws_chat_url, { path: ws_chat_path, reconnection: false });
      
      this.socketChat.on("newMessage", (message, roomId)=>{
        if(this.unreadMessages <=10)
        {
          this.checkUnreadMessages();
        }         
      })   

      //TO-DO rentrer dans toutes les rommes de l'utilisateur
      crService.getAllRooms(this.$auth.token()).then(chatRooms=>{
        chatRooms.forEach(room=>{
          this.socketChat.emit("room", room.uuid)
        })
      })        
    },
    OpenChatSupport() {
      var url = "#/chat/singleConv/quanteec";
      window.open(url, this.userSelected, "width=1200, height=750");
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navbar-nav .dropdown-menu {
  background-color: #113448 !important;
}

@mixin text-color {
  @if (background-color == #fff) {
    color: #14BF98;
  }@else {
    color: #fff;
  }
}

span > #myOptions {
  color: #14BF98;
}

.navitem2 {
  padding: 0.5rem 0.32rem;
}

.navSmallFont {
  font-size: 0.9rem;
}

.logonavbar {
  width:125px;
  margin: 5px 0;
}

</style>